function setLocationReducer(currentState = "25", action) {
  switch (action.type) {
    case "SET_LOCATION":
      return action.payload;
    default:
      break;
  }
  return currentState;
}

export default setLocationReducer;
